module.exports = __webpack_public_path__ + "static/media/First Light ZTG 3776_360.e461b94d.jpeg";